import { render, staticRenderFns } from "./CrearEditar.vue?vue&type=template&id=1f1c7c05&"
import script from "./CrearEditar.vue?vue&type=script&lang=js&"
export * from "./CrearEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports